function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { HttpHeaders } from "./headers";

/**
 * Type enumeration for the different kinds of `HttpEvent`.
 *
 * @publicApi
 */
export var HttpEventType = /*#__PURE__*/function (HttpEventType) {
  HttpEventType[HttpEventType["Sent"] = 0] = "Sent";
  HttpEventType[HttpEventType["UploadProgress"] = 1] = "UploadProgress";
  HttpEventType[HttpEventType["ResponseHeader"] = 2] = "ResponseHeader";
  HttpEventType[HttpEventType["DownloadProgress"] = 3] = "DownloadProgress";
  HttpEventType[HttpEventType["Response"] = 4] = "Response";
  HttpEventType[HttpEventType["User"] = 5] = "User";
  return HttpEventType;
}({});

/**
 * Base interface for progress events.
 *
 * @publicApi
 */

/**
 * A download progress event.
 *
 * @publicApi
 */

/**
 * An upload progress event.
 *
 *
 */

/**
 * An event indicating that the request was sent to the server. Useful
 * when a request may be retried multiple times, to distinguish between
 * retries on the final event stream.
 *
 * @publicApi
 */

/**
 * A user-defined event.
 *
 * Grouping all custom events under this type ensures they will be handled
 * and forwarded by all implementations of interceptors.
 *
 * @publicApi
 */

/**
 * An error that represents a failed attempt to JSON.parse text coming back
 * from the server.
 *
 * It bundles the Error object with the actual response body that failed to parse.
 *
 *
 */

/**
 * Union type for all possible events on the response stream.
 *
 * Typed according to the expected type of the response.
 *
 * @publicApi
 */

/**
 * Base class for both `HttpResponse` and `HttpHeaderResponse`.
 *
 * @publicApi
 */
export var HttpResponseBase = /*#__PURE__*/_createClass(
/**
 * Super-constructor for all responses.
 *
 * The single parameter accepted is an initialization hash. Any properties
 * of the response passed there will override the default values.
 */
function HttpResponseBase(init) {
  var defaultStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var defaultStatusText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'OK';
  _classCallCheck(this, HttpResponseBase);
  /**
   * All response headers.
   */
  _defineProperty(this, "headers", void 0);
  /**
   * Response status code.
   */
  _defineProperty(this, "status", void 0);
  /**
   * Textual description of response status code.
   *
   * Do not depend on this.
   */
  _defineProperty(this, "statusText", void 0);
  /**
   * URL of the resource retrieved, or null if not available.
   */
  _defineProperty(this, "url", void 0);
  /**
   * Whether the status code falls in the 2xx range.
   */
  _defineProperty(this, "ok", void 0);
  /**
   * Type of the response, narrowed to either the full response or the header.
   */
  // TODO(issue/24571): remove '!'.
  _defineProperty(this, "type", void 0);
  // If the hash has values passed, use them to initialize the response.
  // Otherwise use the default values.
  this.headers = init.headers || new HttpHeaders();
  this.status = init.status !== undefined ? init.status : defaultStatus;
  this.statusText = init.statusText || defaultStatusText;
  this.url = init.url || null;

  // Cache the ok value to avoid defining a getter.
  this.ok = this.status >= 200 && this.status < 300;
});

/**
 * A partial HTTP response which only includes the status and header data,
 * but no response body.
 *
 * `HttpHeaderResponse` is a `HttpEvent` available on the response
 * event stream, only when progress events are requested.
 *
 * @publicApi
 */
export var HttpHeaderResponse = /*#__PURE__*/function (_HttpResponseBase) {
  _inherits(HttpHeaderResponse, _HttpResponseBase);
  var _super = _createSuper(HttpHeaderResponse);
  /**
   * Create a new `HttpHeaderResponse` with the given parameters.
   */
  function HttpHeaderResponse() {
    var _this;
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HttpHeaderResponse);
    _this = _super.call(this, init);
    _defineProperty(_assertThisInitialized(_this), "type", HttpEventType.ResponseHeader);
    return _this;
  }
  _createClass(HttpHeaderResponse, [{
    key: "clone",
    value:
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     */
    function clone() {
      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Perform a straightforward initialization of the new HttpHeaderResponse,
      // overriding the current parameters with new ones if given.
      return new HttpHeaderResponse({
        headers: update.headers || this.headers,
        status: update.status !== undefined ? update.status : this.status,
        statusText: update.statusText || this.statusText,
        url: update.url || this.url || undefined
      });
    }
  }]);
  return HttpHeaderResponse;
}(HttpResponseBase);

/**
 * A full HTTP response, including a typed response body (which may be `null`
 * if one was not returned).
 *
 * `HttpResponse` is a `HttpEvent` available on the response event
 * stream.
 *
 * @publicApi
 */
export var HttpResponse = /*#__PURE__*/function (_HttpResponseBase2) {
  _inherits(HttpResponse, _HttpResponseBase2);
  var _super2 = _createSuper(HttpResponse);
  /**
   * Construct a new `HttpResponse`.
   */
  function HttpResponse() {
    var _this2;
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HttpResponse);
    _this2 = _super2.call(this, init);
    /**
     * The response body, or `null` if one was not returned.
     */
    _defineProperty(_assertThisInitialized(_this2), "body", void 0);
    _defineProperty(_assertThisInitialized(_this2), "type", HttpEventType.Response);
    _this2.body = init.body !== undefined ? init.body : null;
    return _this2;
  }
  _createClass(HttpResponse, [{
    key: "clone",
    value: function clone() {
      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new HttpResponse({
        body: update.body !== undefined ? update.body : this.body,
        headers: update.headers || this.headers,
        status: update.status !== undefined ? update.status : this.status,
        statusText: update.statusText || this.statusText,
        url: update.url || this.url || undefined
      });
    }
  }]);
  return HttpResponse;
}(HttpResponseBase);

/**
 * A response that represents an error or failure, either from a
 * non-successful HTTP status, an error while executing the request,
 * or some other failure which occurred during the parsing of the response.
 *
 * Any error returned on the `Observable` response stream will be
 * wrapped in an `HttpErrorResponse` to provide additional context about
 * the state of the HTTP layer when the error occurred. The error property
 * will contain either a wrapped Error object or the error response returned
 * from the server.
 *
 * @publicApi
 */
export var HttpErrorResponse = /*#__PURE__*/function (_HttpResponseBase3) {
  _inherits(HttpErrorResponse, _HttpResponseBase3);
  var _super3 = _createSuper(HttpErrorResponse);
  function HttpErrorResponse(init) {
    var _this3;
    _classCallCheck(this, HttpErrorResponse);
    // Initialize with a default status of 0 / Unknown Error.
    _this3 = _super3.call(this, init, 0, 'Unknown Error');

    // If the response was successful, then this was a parse error. Otherwise, it was
    // a protocol-level failure of some sort. Either the request failed in transit
    // or the server returned an unsuccessful status code.
    _defineProperty(_assertThisInitialized(_this3), "name", 'HttpErrorResponse');
    _defineProperty(_assertThisInitialized(_this3), "message", void 0);
    _defineProperty(_assertThisInitialized(_this3), "error", void 0);
    /**
     * Errors are never okay, even when the status code is in the 2xx success range.
     */
    _defineProperty(_assertThisInitialized(_this3), "ok", false);
    if (_this3.status >= 200 && _this3.status < 300) {
      _this3.message = "Http failure during parsing for ".concat(init.url || '(unknown url)');
    } else {
      _this3.message = "Http failure response for ".concat(init.url || '(unknown url)', ": ").concat(init.status, " ").concat(init.statusText);
    }
    _this3.error = init.error || null;
    return _this3;
  }
  return _createClass(HttpErrorResponse);
}(HttpResponseBase);